import { computed, observable } from 'mobx';
import isNil from 'lodash/isNil';
import { IServiceItemBlockStyles } from '~/types/block-styles.types';
import { IImage, IService, ServiceItemType } from '~/types/model.types';
import { CXContainerableBlock } from '~/components/ClientExperience/OneFlow/models/cx-containerable-block.model';
import { IServiceItemBlockResponse } from '~/types/server.types';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { CXServiceSelectionBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-selection-block.model';

export class CXServiceItemBlock extends CXContainerableBlock {
    type: 'service_selection_item_block' | 'invoice_service_item_block';

    constructor(
        block: IServiceItemBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    @observable service_type: ServiceItemType;
    @observable service_item: IService;
    @observable service_image: IImage;
    @observable styles: IServiceItemBlockStyles;

    get childBlocks() {
        return super.childBlocks as CXServiceItemBlock[];
    }

    get isInPackage() {
        return (
            this.isService &&
            this.parent instanceof CXServiceItemBlock &&
            this.parent.isPackage
        );
    }

    get isServiceSelectionItemBlock() {
        return false;
    }

    get isPackage() {
        return this.service_type === ServiceItemType.Package;
    }

    get isService() {
        return this.service_type === ServiceItemType.Service;
    }

    getDataForInvoice() {
        return this.service_item;
    }

    @computed
    get selectedQuantity(): number {
        return isNil(this.service_item.quantity)
            ? 1
            : this.service_item.quantity;
    }

    @computed
    get totalPrice() {
        const { price_per_unit, quantity } = this.service_item;
        const parsedValue = parseFloat(String(quantity));
        return (Number.isNaN(parsedValue) ? 1 : parsedValue) * price_per_unit;
    }

    @computed
    get invoiceBlock() {
        return this.flow.invoiceContainerBlock;
    }

    @computed
    get serviceSelectionBlock(): CXServiceSelectionBlock {
        let { parent } = this;

        while (parent && parent.type !== 'service_selection_block') {
            parent = parent.parent;
        }

        return parent as CXServiceSelectionBlock;
    }

    @computed
    get isSessionSelection() {
        return (
            !this.isInPackage && this.serviceSelectionBlock.isSessionSelection
        );
    }
}
